import _api from '../../franchises/_api';
import Franchise from '../../../models/Franchise';

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    actual: {},
  },
  // -----------------------------------------------------------------
  getters: {
    actual: (state,) => state.actual,
    /* Modelos de operação obsoletos */
    isDeprecatedModel: ({ actual, },) => {
      return ['70_30',].includes(actual.operating_model,);
    },
  },
  // -----------------------------------------------------------------
  mutations: {
    newFranchise: (state,) => state.actual = new Franchise(),
    setFranchise: (state, franchise,) => state.actual.franchise = franchise,
    cleanFranchise: (state,) => state.actual = {},
  },
  // -----------------------------------------------------------------
  actions: {
    async getFranchiseDetails ({ commit, rootGetters, state, }, franchiseID,) {
      const marketplace_id = rootGetters['user/getMarketplaceFranchise'];
      const fetchFranchise = _api.get({ _id: franchiseID, },);

      if (state.actual._id !== franchiseID) {
        commit('cleanFranchise',);
        commit('newFranchise',);
      }

      return fetchFranchise.then(({data,},) => {
        commit('setFranchise', {
          ...data,
          marketplace_id,
        },);
      },
      (error,) => {
        return _api.handleError(error,);
      },);
    },
    updateFranchise ({ getters, }, valuesToUpdate,) {
      return _api.patch(getters.actual._id, valuesToUpdate,);
    },
    addFranchiseAttachment ({ getters, }, valuesToUpdate,) {
      const attachmentPromises = [];
      valuesToUpdate.forEach((attachment,) => {
        attachmentPromises.push(
          _api.postAttachment(getters.actual._id, attachment,),
        );
      },);
      return Promise.all(attachmentPromises,);
    },
    removeFranchiseAttachment ({ getters, }, idToRemove,) {
      return _api.removeAttachment(getters.actual._id, idToRemove,);
    },
  },
};
